import { FC, PropsWithChildren } from 'react'
import { Skeleton } from '@wellesley/ui'

const TextSkeleton = () => (
  <div className="mt-m flex w-full flex-col gap-xxs">
    {Array.from({ length: 3 }).map((_, idx) => (
      <Skeleton key={idx.toString()} className="h-xxxs w-full rounded-full" />
    ))}
    <Skeleton className="h-xxxs w-[60%] rounded-full" />
  </div>
)

const TabsSkeleton = () => (
  <div className="mt-s flex w-full gap-s">
    {Array.from({ length: 4 }).map((_, idx) => (
      <Skeleton key={idx.toString()} className="h-xxs w-[80px] rounded-sm" />
    ))}
  </div>
)

export const AboutServerTabsContainerSkeleton: FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="mx-auto my-m h-screen max-h-[calc(100vh-40px)] w-screen max-w-[600px] rounded-lg bg-white p-m">
    <div className="flex flex-col items-center">{children}</div>
  </div>
)

export const AboutServerTabsSkeleton: FC = () => (
  <>
    <TabsSkeleton />
    <TextSkeleton />
    <TextSkeleton />
  </>
)
